import { ArrowRightIcon } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { segmentRoute } from '../../../ClientRoutes';
import ProgramStore from '../../../ProgramStore';
import { T, TPlainTextKey } from '../../../Translations';
import { useTranslationsContext } from '../../../Translations/UseTranslationsContext';
import { programCardButtonClassName } from '../../Dashboard/ProgramCard';

interface Props {
  programStore: ProgramStore;
}

const beginOrResumeText = (percentComplete: number): TPlainTextKey =>
  percentComplete === 0 ? 'Begin Course' : 'Resume Course';

function ResumeCourseButton({ programStore }: Props) {
  const { translate } = useTranslationsContext();

  return just({})
    .assign('currentSegment', programStore.currentSegment)
    .assign('percentComplete', programStore.percentComplete)
    .assign('title', programStore.title)
    .map(({ currentSegment, percentComplete, title }) => {
      const buttonText = beginOrResumeText(percentComplete);

      return (
        <Link
          to={segmentRoute(currentSegment)}
          className={programCardButtonClassName}
          data-test-continue-button={buttonText}
          data-intercom-target={
            percentComplete === 0 ? 'begin-program-button' : 'resume-program-button'
          }
          aria-label={`${translate(buttonText)} ${title.text}`}
        >
          <T kind={buttonText} />
          <ArrowRightIcon size="sm" color="inherit" />
        </Link>
      );
    })
    .getOrElse(() => <span />);
}

export default observer(ResumeCourseButton);
